import { formatCurrency} from 'utils/utils';
import { ButtonLink } from './ButtonLink';
import { useEffect, useState } from 'react';

export function BasketContentFooter(props) {
    const { shoppingBag: { totalPrice }, showContinueButton, toggleBascket } = props;
    const [deliveryPrice, setDeliveryPrice] = useState(0)

    useEffect(() => {
        fetchDeliveryPrice()
    }, [totalPrice, toggleBascket])

    const fetchDeliveryPrice = async () => {
        const response = await fetch('/api/orders/delivery-cost')
        const data = await response.json()
        setDeliveryPrice(data)
    }

    return (
        <>
            <div className="body-text6 ptb-20">
                <div className="row mb-8">
                    <div className="col">Subtotal</div>
                    <div className="col-auto body-text7">{formatCurrency(totalPrice)}</div>
                </div>
                <div className="row">
                    <div className="col"><div className='sm-max-width-230'>Delivery (Mainland United Kingdom delivery)</div></div>
                    <div className="col-auto body-text7">{deliveryPrice > 0 ? formatCurrency(deliveryPrice) : "Free"}</div>
                </div>
            </div>
            <div className="dashed-line"></div>
            <div className="mtb-24">
                <span className="subtitle2 uppercase">Total:</span> <span className="body-text1">{formatCurrency(totalPrice + deliveryPrice)}</span>
            </div>
            {
                showContinueButton ? (
                    <div className='gap-2' style={{ display: 'flex', 'flexDirection': 'row' }}>
                        <div className='w-50'>
                            <ButtonLink name='Continue shopping' onClick={(e) => toggleBascket(e, false)} />
                        </div>
                        <div className='w-50'>
                            <ButtonLink name='Checkout now' url="/checkout" />
                        </div>
                    </div>        
                )
                : (
                    <div>
                        <ButtonLink name={showContinueButton ? 'Checkout now' : 'Continue to checkout'} url="/checkout" />
                    </div>
                )
            }
        </>
    );
}